import { render, staticRenderFns } from "./DocumentContent.vue?vue&type=template&id=1d18be49&scoped=true"
import script from "./DocumentContent.vue?vue&type=script&lang=js"
export * from "./DocumentContent.vue?vue&type=script&lang=js"
import style0 from "./DocumentContent.vue?vue&type=style&index=0&id=1d18be49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18be49",
  null
  
)

export default component.exports